define([
	"dojo/_base/declare",
	"csi/state/rootStore",
	"Quality/NewTestRun"
], function(declare,{ routerStore },NewTestRun) {

	return declare(NewTestRun, {
		getFormData: function() {
			// summary: trick csi.form.Widget.getFormNode into using Product as parent, not ProductSample
			var	fd = this.inherited(arguments);
			fd.m_parentNode = this.m_cache.getPathNode(fd.getParent(), "Child:__Parent__/Child:__Parent__/Child:__Parent__", true);
			return fd;
		},

		/**
		 * @override
		 * Product is actually higher up because this is from Sample
		 */
		getTestRunFormParams: function(params) {
		    params = params || {};
		    params.testRunContextNode = routerStore.getBreadcrumbNode("Style") || routerStore.getBreadcrumbNode("Material");
		    params.testRunColor = this.getParent().ProductColor;
		    params.bCanCreateMultipleTestRuns = true;
		}
	});
});